import { typeCreatorV2 } from 'redux/utils/common';

export const SET_CLIENT_DETAILS: string = typeCreatorV2(
  'ViewUserInfoReducer',
  'SetClientDetails'
);
